import AlciSivaModal from '@pages/Insaat/Ince/AlciSiva/AlciSivaModal';
import BoyaModal from '@pages/Insaat/Ince/Boya/BoyaModal';
import KapiPencereModal from '@pages/Insaat/Ince/KapiPencere/KapiPencereModal';
import ParkeModal from '@pages/Insaat/Ince/Parke/ParkeModal';
import SeramikModal from '@pages/Insaat/Ince/Seramik/SeramikModal';
import AsansorModal from '@pages/Insaat/Tesisat/Asansor/AsansorModal';
import DogalgazModal from '@pages/Insaat/Tesisat/Dogalgaz/DogalgazModal';
import ElektrikModal from '@pages/Insaat/Tesisat/Elektrik/ElektrikModal';
import HavalandirmaModal from '@pages/Insaat/Tesisat/Havalandirma/HavalandirmaModal';
import SuTesisatiModal from '@pages/Insaat/Tesisat/SuTesisati/SuTesisatiModal';
import BanyoModal from '@pages/Insaat/IcMekan/Banyo/BanyoModal';
import GardropModal from '@pages/Insaat/IcMekan/Gardrop/GardropModal';
import MutfakModal from '@pages/Insaat/IcMekan/Mutfak/MutfakModal';
import DemirModal from '@pages/Insaat/Kaba/Demir/DemirModal';
import BetonModal from '@pages/Insaat/Kaba/Beton/BetonModal';
import TuglaModal from '@pages/Insaat/Kaba/Tugla/TuglaModal';
import IzolasyonModal from '@pages/Insaat/Kaba/Izolasyon/IzolasyonModal';
import ForeKazikModal from '@pages/Insaat/Kaba/ForeKazik/ForeKazikModal';
import CatiModal from '@pages/Insaat/Ince/Cati/CatiModal';

/**
 * MaterialModalRouter — Senaryo B için malzeme modal yönlendirici
 *
 * PlanliOdemeModal'dan kullanılır. Alt kategori seçilince doğru malzeme
 * modalını render eder ve onMaterialSubmit callback'i ile hesaplanan
 * toplam + firma bilgisini geri döndürür.
 */

const MODAL_MAP = {
    // Kaba
    demir: DemirModal,
    beton: BetonModal,
    tugla: TuglaModal,
    izolasyon: IzolasyonModal,
    fore_kazik: ForeKazikModal,
    cati: CatiModal,
    // İnce İşler
    alci_siva: AlciSivaModal,
    boya: BoyaModal,
    kapi_pencere: KapiPencereModal,
    parke: ParkeModal,
    seramik: SeramikModal,
    // Tesisat
    asansor: AsansorModal,
    dogalgaz: DogalgazModal,
    elektrik: ElektrikModal,
    havalandirma: HavalandirmaModal,
    su_tesisati: SuTesisatiModal,
    // İç Mekan
    banyo: BanyoModal,
    gardrop: GardropModal,
    mutfak: MutfakModal,
};

export default function MaterialModalRouter({
    subcategory,
    isOpen,
    onClose,
    onMaterialSubmit,
    insaatId,
}) {
    const ModalComponent = MODAL_MAP[subcategory];

    if (!ModalComponent || !isOpen) return null;

    return (
        <ModalComponent
            isOpen={isOpen}
            onClose={onClose}
            onMaterialSubmit={onMaterialSubmit}
            submitLabel="Hesapla & Dön"
            insaatId={insaatId}
        />
    );
}

export const MATERIAL_SUBCATEGORIES = [
    // Kaba İnşaat
    { key: 'demir', label: 'İnşaat Demiri', unit: 'ton', group: 'Kaba İnşaat' },
    { key: 'beton', label: 'Hazır Beton', unit: 'm³', group: 'Kaba İnşaat' },
    { key: 'tugla', label: 'Tuğla / Bims', unit: 'adet', group: 'Kaba İnşaat' },
    { key: 'izolasyon', label: 'İzolasyon', unit: 'm²', group: 'Kaba İnşaat' },
    { key: 'fore_kazik', label: 'Fore Kazık', unit: 'adet', group: 'Kaba İnşaat' },
    { key: 'cati', label: 'Çatı Malzemesi', unit: 'm²', group: 'Kaba İnşaat' },
    // İnce İşler
    { key: 'alci_siva', label: 'Alçı / Sıva', unit: 'm²', group: 'İnce İşler' },
    { key: 'boya', label: 'Boya', unit: 'kg', group: 'İnce İşler' },
    { key: 'kapi_pencere', label: 'Kapı / Pencere', unit: 'adet', group: 'İnce İşler' },
    { key: 'parke', label: 'Parke', unit: 'm²', group: 'İnce İşler' },
    { key: 'seramik', label: 'Seramik', unit: 'm²', group: 'İnce İşler' },
    // Tesisat
    { key: 'asansor', label: 'Asansör', unit: 'adet', group: 'Tesisat' },
    { key: 'dogalgaz', label: 'Doğalgaz Tesisatı', unit: 'm', group: 'Tesisat' },
    { key: 'elektrik', label: 'Elektrik Tesisatı', unit: 'm', group: 'Tesisat' },
    { key: 'havalandirma', label: 'Havalandırma', unit: 'adet', group: 'Tesisat' },
    { key: 'su_tesisati', label: 'Su Tesisatı', unit: 'm', group: 'Tesisat' },
    // İç Mekan
    { key: 'banyo', label: 'Banyo Malzemesi', unit: 'adet', group: 'İç Mekan' },
    { key: 'gardrop', label: 'Gardrop', unit: 'adet', group: 'İç Mekan' },
    { key: 'mutfak', label: 'Mutfak', unit: 'adet', group: 'İç Mekan' },
];
